<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      ქართული თხილის ევროპული პერსპექტივები<br />
      Nuts Incorporated
    </h1>
    <h6>დეკემბერი 2023</h6>
    <br />

    <p>
      იცოდი, რომ ყველასთვის საყვარელი იტალიური შოკოლადის „ფერერო როშეს“ ნაწილში, შუაგულში მოთავსებული თხილი ქართულია?!
      სანამ მოგიყვებით თუ როგორ აღმოჩნდა ჩვენთან მოყვანილი პროდუქტი ევროპის ცენტრში, ერთ-ერთი წამყვანი ბრენდის
      საწარმოში, საინტერესო დეტალებს გაგაცნობთ.
    </p>

    <img src="../../../../assets/blog/nuts/img1.jpg" alt="" />

    <p>
      კაკლოვანი კულტურების პროდუქცია მიეკუთვნება იმ იშვიათ სახეობას, რომლის ფასები მსოფლიო ბაზარზე ზრდის სტაბილური
      ტენდენციით ხასიათდება. კერძოდ, ევროკავშირის ქვეყნებში აღნიშნული მიმართულებით მოთხოვნა და პროდუქტის ფასი სულ უფრო
      იზრდება, შესაბამისად, ქართველი მეწარმეების დაინტერესებაც მზარდია.
    </p>

    <p>
      2021 წლის 1 აგვისტოდან 2022 წლის 13 თებერვლის ჩათვლით საქართველოდან 19.7 ათასი ტონა თხილის ექსპორტი განხორციელდა,
      რომლის ღირებულებამ 90.4 მლნ აშშ დოლარი შეადგინა. გასული წლის ანალოგიურ პერიოდთან შედარებით, ექსპორტირებული თხილის
      მოცულობა 4.1 ათასი ტონით (26%), ხოლო ღირებულება 7.4 მლნ აშშ დოლარით (9%) გაიზარდა. მნიშვნელოვანია ის ფაქტიც, რომ
      ექსპორტის ქვეყნები დივერსიფიცირებულია.
    </p>

    <p>
      Nuts Incorporated ნუშისა და თხილის ბაღების სიდიდით პირველი კომპანიაა ქვეყანაში. ამ ეტაპზე ორგანიზაცია 3000 ჰა-ზე
      გაშენებულ ბაღებს მართავს, საიდანაც 700 ჰა-ზე ნუშის პლანტაციები მცხეთა-მთიანეთისა და ქვემო ქართლში მდებარეობს, ხოლო
      2 300 ჰა თხილის ბაღები სამეგრელოშია.
    </p>

    <img src="../../../../assets/blog/nuts/img2.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="padding-top: 20px">
      <div class="container" style="max-width: 800px;">
        <p class="quote quote-sign left-align">“</p>

        <p class="quote left-align">
          „ჩვენ მუდმივად ვახორციელებთ ინვესტიციებს უახლეს ტექნოლოგიებსა და კვალიფიციურ კადრებში, რომლებიც ზედმიწევნით
          ამუშავებენ თითოეულ პროდუქტს კულტივაციიდან - წარმოებამდე. სწორედ ეს უზრუნველყოფს ჩვენი თხილის უმაღლეს
          ხარისხსს.“
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      Nuts Incorporated-ი ბაზარზე თხილის ერთ-ერთი უმსხვილესი მიმწოდებელია, რომელიც მაღალი ხარისხის თხილის ექსპორტს
      როგორც ევროპის ასევე გალფის და სხვა ქვეყნებში ახორციელებს.
    </p>
    <p>
      კომპანიის მრავალწლოვანი თხილის ბაღები მაქსიმალურ მოსავლიანობას 2025 წლისთვის მიაღწევს. სუპერნოვას, ლორენის, გუარას
      ჯიშების წლიური და ორწლიური ბაღები კი ნაყოფის მომტანი 2023 წელს, მაქსიმალურ მოსავალის კი - 2025 წელს გახდება.
    </p>
    <img src="../../../../assets/blog/nuts/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="padding-top: 20px">
      <div class="container" style="max-width: 800px;">
        <p class="quote quote-sign left-align">“</p>

        <p class="quote left-align">
          „პირველადი წარმოებიდან გადამუშავებამდე, ჩვენი ოპერაციები იცავს გლობალურად აღიარებული სერტიფიკატების მკაცრ
          მოთხოვნებს, მათ შორის Global Gap პირველადი წარმოებისთვის და ISO9000 და BRC გადამუშავებისთვის. ეს სერტიფიკატები
          ადასტურებს ჩვენს ვალდებულებას მივაწოდოთ განსაკუთრებული პროდუქტები, რომლებიც არა მხოლოდ აკმაყოფილებს, არამედ
          აღემატება ჩვენი ძვირფასი მომხმარებლების მოლოდინს.“
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      თიბისი ლიზინგისთვის განსაკუთრებით მნიშვნელოვანია ისეთი ბიზნესის მხარდაჭერა, რომელიც როგორც არსებული, ასევე
      სამომავლო პერსპექტივით მნიშვნელოვანი კეთილდღეობის შემქმნელია, ამიტომ, Nuts Incorporated-ს ეფექტური აგრარული
      საქმიანობისთვის მძიმე ტექნიკა - ტრაქტორები და მოსავლის ამღებები 2 ინვესტიციით დავაფინანსეთ.
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      Georgian Hazelnut's European Perspectives <br />
      Nuts Incorporated
    </h1>
    <h6>December 2023</h6>
    <br />

    <p>
      Did you know that the hazelnut at the center of everyone's favorite Italian chocolate, "Ferrero Rocher," is
      Georgian?! Before telling you how our locally grown product ended up in the heart of Europe, in one of the leading
      brand's factories, I will share some interesting details with you.
    </p>

    <img src="../../../../assets/blog/nuts/img1.jpg" alt="" />

    <p>
      The production of nut crops belongs to a rare category, characterized by a stable upward trend in prices on the
      global market. Specifically, in European Union countries, the demand and price for these products are steadily
      increasing, which is why Georgian entrepreneurs' interest in this sector is also growing.
    </p>

    <p>
      From August 1, 2021, to February 13, 2022, Georgia exported 19.7 thousand tons of hazelnuts, valued at 90.4
      million USD. Compared to the same period last year, the volume of exported hazelnuts increased by 4.1 thousand
      tons (26%), and the value increased by 7.4 million USD (9%). It is also important to note that the countries of
      export are diversified.
    </p>

    <p>
      Nuts Incorporated is the largest company in the country in terms of almond and hazelnut orchards. Currently, the
      organization manages orchards spread over 3000 hectares, with 700 hectares of almond plantations located in
      Mtskheta-Mtianeti and Kvemo Kartli, and 2300 hectares of hazelnut orchards in Samegrelo.
    </p>

    <img src="../../../../assets/blog/nuts/img2.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="padding-top: 20px">
      <div class="container" style="max-width: 800px;">
        <p class="quote quote-sign left-align">“</p>

        <p class="quote left-align">
          “We continuously invest in the latest technologies and qualified personnel who meticulously work on each
          product from cultivation to production. This ensures the highest quality of our hazelnuts.”
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      Nuts Incorporated is one of the largest suppliers of hazelnuts in the market, exporting high-quality hazelnuts to
      Europe, the Gulf region, and other countries.
    </p>
    <p>
      The old hazelnut orchards of the company are expected to reach maximum yield by 2025. The annual and biennial
      orchards of the Supernova, Lorene, and Guara varieties will start bearing fruit in 2023, with maximum yields
      expected by 2025.
    </p>
    <img src="../../../../assets/blog/nuts/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="padding-top: 20px">
      <div class="container" style="max-width: 800px;">
        <p class="quote quote-sign left-align">“</p>

        <p class="quote left-align">
          “From primary production to processing, our operations adhere to the strict requirements of globally
          recognized certifications, including Global Gap for primary production and ISO9000 and BRC for processing.
          These certifications confirm our commitment to providing exceptional products that not only meet but exceed
          the expectations of our valued customers.”
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      For TBC Leasing, it is especially important to support businesses that contribute significantly to both current
      and future prosperity. Therefore, we financed heavy machinery—tractors and harvesters—for Nuts Incorporated
      through two investments, enabling efficient agricultural operations.
    </p>
  </div>
</ng-container>
